import { createSlice } from "@reduxjs/toolkit";
import { IStudentCourceDetailSlice } from "../../../models/student/studentCourceDetail";

const InitialStudentCourceDetails: IStudentCourceDetailSlice = {
  studentCourceDetail: undefined,
};

const studentCourceDetailSlice = createSlice({
  name: "studentCourceDetail",
  initialState: InitialStudentCourceDetails,
  reducers: {
    setStudentCourceDetail: (state, action: { payload: any }) => {
      state.studentCourceDetail = action.payload;
    },
  },
});

export const { setStudentCourceDetail } = studentCourceDetailSlice.actions;


const studentCourceDetailReducer = studentCourceDetailSlice.reducer;

export type studentCourceDetailState = ReturnType<typeof studentCourceDetailReducer>;

export default studentCourceDetailReducer;



